import React from "react";
import '../../styling/RevenueInfoTile.css';
import { useState, useEffect } from "react";
import axios from "axios";


const EventInfoTile = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchDashboardTileData();
  }, []);


  const fetchDashboardTileData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard-tile`, {
        withCredentials: true,
      });
      setData(response.data.data);
      // console.log(data);
    } catch (error) {
      console.log("Error fetching dashboard tile data... ", error);
    }
  };

  let totalEvents = 0;
  let totalPendingPayments = 0;
  let completedEvents = 0;
  let upcomingEvents = 0;

  if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0]) && data[0].length > 0 && typeof data[0][0] === 'object') {
    // Access the values from the nested objects



     totalEvents = data[0][0]?.totalEvents;
    totalPendingPayments = data[1][0]?.totalPendingPayments || 0;
    completedEvents = data[2][0]?.completedEvents || 0;



    upcomingEvents = data[3][0]?.upcomingEvents || 0 ;
  } 

    

    const column = {
        flex: "1",
        border: "1px solid #D9D9D9",
        borderLeft: "hidden",
        borderTop: "hidden",
        marginLeft: "30px",
        textAlign: "left", 
        height: "65.5%",
        color: "#625C73",
        marginTop: "16px",
        borderBottom: "hidden"
    };

    const pStyle = { marginTop: '0px', marginBottom: '10px'};
    const lastColumn = {...column, borderRight: "hidden"};

  return (
    <div
    className="event-info-wrapper"
      style={{
        width: "100%",
        background: "#FFFFFF",
        marginTop: "29px",
        display: "flex",
        border: "1px solid #D9D9D9",
        borderBottom: "hidden",
        borderRadius: '5px',
        boxShadow: '0px 2px 4px #15223214',
      }}
    >
      <div class="column">
        <p style={pStyle}> Total Events</p>
        <h1 style={{ color: '#1C1154'}}>{totalEvents}</h1>
      </div>
      <div class="column">
        <p style={pStyle}> Upcoming Events </p>
        <h1 style={{ color: '#1C1154'}}>{upcomingEvents}</h1>
      </div>
      <div class="column">
        <p style={pStyle}> Completed Events</p>
        <h1 style={{ color: '#1C1154'}}>{completedEvents}</h1>
      </div>
      <div class="column">
        <p style={pStyle}>Pending Payments</p>
        <h1 style={{ color: '#1C1154'}}>{totalPendingPayments}</h1>
      </div>
    </div>
  );
};

export default EventInfoTile;
